// Identity matching is presentation only; the backend still authorizes equipment.
const text = value => typeof value === 'string' ? value.trim() : '';
const chains = { ethereum: 'eth', '1': 'eth', '0x1': 'eth', '43114': 'avalanche', '0xa86a': 'avalanche', '137': 'polygon', '0x89': 'polygon' };
function token(value) {
  if (typeof value === 'number' && (!Number.isSafeInteger(value) || value < 0)) return '';
  const raw = typeof value === 'number' ? String(value) : text(value);
  if (/^(?:\d+|0x[\da-f]+)$/i.test(raw)) return BigInt(raw).toString();
  return raw; // Catalog cards can use nonnumeric identifiers.
}
export function nftIdentity(item) {
  if (!item) return null;
  const chain = text(item.chain || item.chainId).toLowerCase();
  const address = text(item.token_address ?? item.tokenAddress ?? item.contract).toLowerCase();
  const id = token(item.token_id ?? item.tokenId ?? item.id);
  return chain && address && id ? [chains[chain] ?? chain, address, id] : null;
}
export function sameNft(a, b) {
  const left = nftIdentity(a), right = nftIdentity(b);
  return !!left && !!right && left.every((part, index) => part === right[index]);
}
export function resolveEquippedNft(items, reference, legacyId) {
  const identity = nftIdentity(reference);
  let matches;
  if (identity) {
    matches = items.filter(item => sameNft(item, reference));
  } else {
    // Do not ignore partial chain/contract information to guess a different NFT.
    if (reference && (reference.chain || reference.chainId || reference.token_address || reference.tokenAddress || reference.contract)) return null;
    const id = token(reference?.token_id ?? reference?.tokenId ?? reference?.id ?? legacyId);
    if (!id) return null;
    matches = items.filter(item => token(item.token_id ?? item.tokenId ?? item.id) === id);
  }
  return matches.length === 1 && !matches[0].isStaked ? matches[0] : null;
}

export function equipmentPayload(item, requestedChain, nftType) {
  const identity = nftIdentity(item);
  if (!identity || !['eth', 'avalanche', 'polygon'].includes(identity[0])) {
    throw new Error('Cannot update equipment: missing or unsupported NFT identity');
  }
  if (requestedChain != null) {
    const raw = text(requestedChain).toLowerCase();
    if ((chains[raw] ?? raw) !== identity[0]) throw new Error('Cannot update equipment: network does not match item');
  }
  const [chain, tokenAddress, tokenId] = identity;
  return {chain, tokenAddress, tokenId, ...(nftType ? {nftType} : {})};
}
